import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import KPICard from "@/components/KPICard";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { Activity, Database, Users, Building2, ServerCrash, HardDrive } from "lucide-react";
import { TID } from "@/constants/testIds";

export default function AdminMonitoring() {
  const [m, setM] = useState(null);

  useEffect(() => {
    api.get("/admin/health-overview").then(({ data }) => setM(data)).catch(() => {});
  }, []);

  return (
    <Layout title="Monitoramento" subtitle="Saúde da API, banco de dados e armazenamento">
      <div data-testid={TID.adminMonitoring} className="space-y-6">
        <section className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <KPICard label="Empresas" value={m?.total_companies || 0} icon={Building2} testId="monitor-companies" />
          <KPICard label="Usuários" value={m?.total_users || 0} icon={Users} testId="monitor-users" />
          <KPICard label="Unidades" value={m?.total_units || 0} icon={Building2} testId="monitor-units" />
          <KPICard label="Entradas auditoria" value={m?.total_audit_entries || 0} icon={Database} testId="monitor-audit" />
        </section>

        <section className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Card className="p-6 rounded-xl border-stone-200 bg-white">
            <div className="flex items-center gap-2">
              <Activity className="h-4 w-4 text-emerald-800" />
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-stone-500 font-body">Latência API</div>
            </div>
            <div className="mt-3 font-display text-3xl font-extrabold">{m?.api_latency_ms ?? 0}<span className="text-sm text-stone-500 font-medium">ms</span></div>
            <div className="text-xs text-stone-500 mt-1 font-body">Média últimos 5 min</div>
          </Card>
          <Card className="p-6 rounded-xl border-stone-200 bg-white">
            <div className="flex items-center gap-2">
              <ServerCrash className="h-4 w-4 text-amber-600" />
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-stone-500 font-body">Taxa de erro</div>
            </div>
            <div className="mt-3 font-display text-3xl font-extrabold">{(m?.error_rate ?? 0).toFixed(2)}%</div>
            <div className="text-xs text-stone-500 mt-1 font-body">Janela de 1h</div>
          </Card>
          <Card className="p-6 rounded-xl border-stone-200 bg-white">
            <div className="flex items-center gap-2">
              <HardDrive className="h-4 w-4 text-emerald-800" />
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-stone-500 font-body">Storage usado</div>
            </div>
            <div className="mt-3 font-display text-3xl font-extrabold">{(m?.storage_used_gb ?? 0).toFixed(1)}<span className="text-sm text-stone-500 font-medium"> GB</span></div>
            <div className="text-xs text-stone-500 mt-1 font-body">Buckets agregados</div>
          </Card>
        </section>
      </div>
    </Layout>
  );
}
